<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editGrade="selectedGrade"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(49)"
        title="Grade"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="grades"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.createdAt | moment("LL") }}</td>
            <td class="text-left">{{ item.title }}</td>
            <td class="text-left">
              <div v-if="item.ClassRoom">{{ item.ClassRoom.name }}</div>
              <div v-else>N/A</div>
            </td>
            <td class="text-left">
              <div v-if="item.Student">{{ item.Student.fullName }}</div>
              <div v-else>N/A</div>
            </td>
            <td class="text-left">
              <div v-if="item.Term">{{ item.Term.name }}</div>
              <div v-else>N/A</div>
              <div v-if="item.Term && item.Term.Year">{{ item.Term.Year.name }}</div>
            </td>
            <td class="text-right">
              <div>{{ item.totalMarks }}</div>
            </td>
            <td class="text-right">
              <div>{{ item.ObtainedMarks }}</div>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(51)"
                    @click="editGrade(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    v-if="checkRightStatus(52)"
                    @click="deleteGrade(item.id)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import gradeService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "grade-list",
  data() {
    return {
      createDialog: false,
      selectedGrade: null,
      headers: [
        {
          text: 'Created At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Title",
          align: "left",
          value: "title",
          sortable: true,
        },
        {
          text: "Classroom",
          align: "left",
          value: "ClassRoom.name",
          sortable: true,
        },
        {
          text: "Student",
          align: "left",
          value: "Student.fullName",
          sortable: true,
        },
        {
          text: "Term",
          align: "left",
          value: "Term.name",
          sortable: true,
        },
        {
          text: "Total Marks",
          align: "right",
          value: "totalMarks",
          sortable: true,
        },
        {
          text: "Obtained Marks",
          align: "right",
          value: "ObtainedMarks",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      grades: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
      editDialog: null,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Grade List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.createDialog = false
      return gradeService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.grades = response.data;
        return response;
      });
    },
    editGrade(grade) {
      this.selectedGrade = grade;
      this.editDialog = !this.editDialog;
    },
    deleteGrade(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          gradeService.delete(id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Grade has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
